import { CssClasses, Spacing } from '../types/appTypes';

export class LayoutUtil {
  static spacingToCss = (
    part: string,
    spacing: Spacing[] | undefined,
    css: CssClasses
  ): string => {
    let classes: string[] = [];

    if (spacing !== undefined && spacing.length > 0) {
      if (spacing.length === 1) {
        classes.push(css[LayoutUtil.spacingSizeToCss(part, '', spacing[0])]);
      } else if (spacing.length < 4) {
        classes.push(css[LayoutUtil.spacingSizeToCss(part, 'Top', spacing[0])]);
        classes.push(
          css[LayoutUtil.spacingSizeToCss(part, 'Bottom', spacing[0])]
        );
        classes.push(
          css[LayoutUtil.spacingSizeToCss(part, 'Left', spacing[1])]
        );
        classes.push(
          css[LayoutUtil.spacingSizeToCss(part, 'Right', spacing[1])]
        );
      } else {
        classes.push(css[LayoutUtil.spacingSizeToCss(part, 'Top', spacing[0])]);
        classes.push(
          css[LayoutUtil.spacingSizeToCss(part, 'Left', spacing[1])]
        );
        classes.push(
          css[LayoutUtil.spacingSizeToCss(part, 'Bottom', spacing[2])]
        );
        classes.push(
          css[LayoutUtil.spacingSizeToCss(part, 'Right', spacing[3])]
        );
      }
    }

    return classes.join(' ');
  };

  static spacingSizeToCss = (
    part: string,
    side: string,
    size: Spacing
  ): string => {
    return `${part}${side}${Spacing[size]}`;
  };
}
